import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';

@Injectable()
export class LoggingErrorHandlerService {
  logError(message: string, stack: string): string {
    if (!environment.production) {
      console.error(`LoggingService: ${message}, ${stack}`);
    }

    return `LoggingService: ${message}, ${stack}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/@compartidos/services/logging-error-handler.service.ts